import { Container, Row, Col } from 'react-bootstrap';

export const NoMatch = () => {
	return (
		<Container>
			<Row>
				<Col>
					<h1>No Match</h1>
				</Col>
			</Row>
		</Container>
	);
};
